import { Redirect, truthy } from "@quortex/front-common"
import { type DefaultGenerics, Navigate, Outlet, type Route } from "@tanstack/react-location"
import { lazy } from "react"
import { playRoutes } from "src/App/play/routes"
import urlJoin from "url-join"

// Misc
const Root = lazy(() => import("./Root"))

const Organization = lazy(() =>
  import("@quortex/front-common").then(module => ({ default: module.Organization }))
)

const NotFound = lazy(() =>
  import("@quortex/front-common").then(module => ({ default: module.NotFound }))
)

export const portalTree: Route<DefaultGenerics> = {
  path: "/",
  element: <Root />,
  children: [
    {
      path: "organizations/new",
      element: (
        <Redirect
          external
          replace
          to={urlJoin(import.meta.env.REACT_APP_PORTAL_URL, "/organizations/new")}
        />
      )
    },
    {
      path: "organizations/:orgUuid",
      element: (
        <Organization>
          <Outlet />
        </Organization>
      ),
      children: [
        // App routes
        playRoutes,

        {
          path: "home",
          element: <Navigate to="../play" />
        },
        {
          path: "link",
          element: <Navigate to="../play" />
        },
        // Fallback
        { element: <NotFound /> }
      ]
    },

    { element: <NotFound /> }
  ].filter(truthy)
}
